import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './list_item.css';

export default (props) => {

  const item = props.item;

  return <div className={'list_item'}>
      <h4 className={'list_headline'}>
        <Link to={`/${props.type}/${item.id}`}>{item.headline}</Link>
      </h4>
      <div className={'list_line'} />
      <p>
        {props.type === 'angebot' && 'Verfügbare Schlafplätze:'}
        {props.type === 'gesuch' && 'Benötigte Schlafplätze:'}
        &nbsp;{item.number}
        </p>
      <div className={'list_icons'}>
        {item.kids === 1 && <FontAwesomeIcon icon="baby-carriage" />}
        {item.pets === 1 && <FontAwesomeIcon icon="paw" />}
        {item.smoking === 1 && <FontAwesomeIcon icon="smoking" />}
        {item.accessible === 1 && <FontAwesomeIcon icon="wheelchair" />}
      </div>
    </div>;
}